import { InputArgumentSpecBase } from "abweb/dto/generated/gds/InputArgumentSpecBase";
export class InputArgumentSpec extends InputArgumentSpecBase {
  constructor() {
    super();
  }
}
//# sourceMappingURL=InputArgumentSpec.js.map
